module.exports = __webpack_public_path__ + "static/media/berezovska-hat.a3b0389a.png";